import React, { useState } from "react";
import PropTypes from "prop-types";

import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from "@material-ui/icons";

import "./form.scss";

function TextField({
  type = "text",
  label,
  name,
  isDisabled,
  value,
  autocomplete,
  onChange,
  required,
  className,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const renderVisibilityIcons = () => (
    <div
      className="password-visibility"
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
    </div>
  );

  return (
    <div
      className={`text-field ${required ? "text-field-required" : " "} ${className} `}
    >
      <label htmlFor={name} className="editor-form-section-title">
        {label}
      </label>
      <input
        autoComplete={autocomplete}
        type={showPassword ? "text" : type}
        required={required ? "required" : null}
        id={name}
        name={name}
        disabled={isDisabled}
        value={value}
        onChange={onChange}
      />
      {type === "password" && renderVisibilityIcons()}
    </div>
  );
}

TextField.defaultProps = {
  autocomplete: "off",
  type: "text",
  label: "",
  name: "text-field",
  isDisabled: false,
  value: "",
  className: "",
  onChange: () => {},
  required: false,
};

TextField.propTypes = {
  autocomplete: PropTypes.string, // The type of autocomplete
  type: PropTypes.oneOf(["text", "password", "email"]), // The type of the text field
  label: PropTypes.string, // The label of the text field
  name: PropTypes.string, // The name of the text field
  isDisabled: PropTypes.bool, // Whether the text field is disabled
  value: PropTypes.string, // The value of the text field
  onChange: PropTypes.func, // The function to call when the text field is changed
  className: PropTypes.string, // The class name to apply to the text field
  required: PropTypes.bool, // Whether the text field is required
};

export default TextField;
